import { render } from "./CheckOrXMark.vue?vue&type=template&id=48814880"
import script from "./CheckOrXMark.vue?vue&type=script&lang=js"
export * from "./CheckOrXMark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__